import {
  Context,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useState,
} from 'react';

export const createLegendFilterContext = <
  TLegendFilter extends Record<string, unknown>,
>(
  defaultLegendFilters: TLegendFilter,
) => {
  return createContext<{
    legendFilters: TLegendFilter;
    setLegendFilters: Dispatch<SetStateAction<TLegendFilter>>;
  }>({ legendFilters: defaultLegendFilters, setLegendFilters: () => {} });
};

export const LegendFilterProvider = <
  TLegendFilter extends Record<string, unknown>,
>({
  children,
  defaultLegendFilters,
  legendFilterContext: legendFilterContext,
}: PropsWithChildren<{
  defaultLegendFilters: TLegendFilter;
  legendFilterContext: Context<{
    legendFilters: TLegendFilter;
    setLegendFilters: Dispatch<SetStateAction<TLegendFilter>>;
  }>;
}>) => {
  const [legendFilters, setLegendFilters] =
    useState<TLegendFilter>(defaultLegendFilters);

  return (
    <legendFilterContext.Provider value={{ legendFilters, setLegendFilters }}>
      {children}
    </legendFilterContext.Provider>
  );
};
